var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Inventory box contains weight from the following Check-Ins: "),_vm._l((_vm.context.data),function(checkInId){return _c('router-link-id',{key:checkInId,attrs:{"name":"check-in","id":checkInId}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }